import m, {Vnode} from "mithril";
import ICustomForm from "../../ICustomForm";
import CFNumber from "../CFNumber";
import ICustomFormSettings from "../../ICustomFormSettings";
import ScrollItem from "../../shared/components/HorizontalScrollPicker/ScrollItem";
import HorizontalScrollPicker from "../../shared/components/HorizontalScrollPicker/HorizontalScrollPicker";

export default class NumberAge extends CFNumber implements ICustomForm
{
    private readonly picker: HorizontalScrollPicker;
    private picture: "baby"|"human-child"|"teenager"|"human-handsup"|"pensioner" = "baby";

    constructor(settings: ICustomFormSettings) {
        super(settings);

        const items: ScrollItem[] = [];
        for (let i = 0; i<100; i++) {
            items.push( new ScrollItem(''+i, ''+i) );
        }
        items.push( new ScrollItem('99+', '100') );

        this.picker = new HorizontalScrollPicker(
            items,
            this.numberInputCell,
            this.getVariable(this.variableName) || 30,
            this.onSelect.bind(this),
            this.onScrollOver.bind(this),
            30
        );
    }

    private onSelect(item: ScrollItem) {
        this.setVariable(this.variableName, item.value);
    }

    private onScrollOver(item: ScrollItem) {
        const value = Number(item.value);
        if (value < 5) {
            this.picture = "baby";
        } else if (value < 12) {
            this.picture = "human-child";
        } else if (value < 21) {
            this.picture = "teenager";
        } else if (value < 60) {
            this.picture = "human-handsup";
        } else {
            this.picture = "pensioner";
        }
    }


    public view() {
        const form = this.settings.form;
        const questionary = form.questionary;

        return this.viewLayout([
            m('div.picture', {}, m('.icon.icon-'+this.picture)),
            this.viewPicker(),
            m('p.hint', {}, questionary.renderText(questionary.messages.get('swipeToSelectAge'))),
            m('.', {}, this.checkboxes.map(cell => m(cell))),
        ]);
    }

    private viewPicker(): Vnode {
        return m(this.picker);
    }
}